import { gql } from '@/lib/graphql/gql'

export const OBJECT_STORAGE_DISPLAY_NAME_QUERY = gql`
  query ObjectStorageDisplayName(
    $idCompany: String!
    $idObjectStorage: String!
  ) {
    company(id: $idCompany) {
      id
      objectStorage(id: $idObjectStorage) @live {
        id
        idCompany
        idProject
        displayName
        status
      }
    }
  }
`
